<template>
  <div>
    <canvas v-if="pallet.products.length > 0" :id="canvasId"></canvas>
  </div>
</template>

<script>
export default {
  props: ["pallet", "divider", "resizeSelf", "truck"],
  data() {
    return {
      canvasId: this.getCanvasId()
    };
  },
  mounted() {
    this.drawSideView(this.pallet);
    window.addEventListener("resize", () => {
      this.drawSideView(this.pallet);
    });
  },
  watch: {
    pallet() {
      this.drawSideView(this.pallet);
      this.canvasId = this.getCanvasId();
    },
    divider() {
      this.drawSideView(this.pallet);
    },
    truck() {
      this.drawSideView(this.pallet);
    }
  },
  methods: {
    /**
     * draws side view of pallet
     * @param pallet
     */
    drawSideView(pallet) {
      if (pallet.products.length == 0) return;
      const divider = this.resizeSelf ? this.getDivider() : this.divider;
      let dimensions = {
        divider: divider
      };
      let canvas = document.getElementById(this.canvasId);
      if (!canvas) return;
      let ctx = canvas.getContext("2d");
      canvas.width = (pallet.width * 4) / 3 / dimensions.divider;
      canvas.height =
        ((getHighestProduct(pallet.products) + pallet.pallet_height) * 11) /
        10 /
        dimensions.divider;
      ctx.scale(1 / dimensions.divider, 1 / dimensions.divider);
      ctx.linWidth = 100 * (1 / dimensions.divider);
      drawBase(ctx, pallet, dimensions);
      drawProducts(ctx, pallet, dimensions, this);
    },

    /**
     * gets divider for side view
     */
    getDivider() {
      if (this.pallet.products.length == 0) {
        return 0;
      }
      const palletHeight = this.palletObj.getPalletHeightInTruck(this.pallet);
      let sideCounter = 3;
      while (palletHeight / sideCounter > window.innerHeight / 4.5) {
        sideCounter++;
      }
      return sideCounter;
    },

    getCanvasId() {
      const random = Math.floor(Math.random() * 1000000);
      return `canvas${this.pallet.id}${random}`;
    }
  }
};

/**
 * draws pallet base
 * @param ctx - canvas context
 * @param pallet
 * @param dimensions
 */
function drawBase(ctx, pallet) {
  ctx.fillStyle = pallet.printable ? "#FF0000" : "gray";

  ctx.fillRect(
    0,
    getHighestProduct(pallet.products),
    pallet.width,
    pallet.pallet_height
  );
  ctx.stroke();
}

/**
 * draws products on pallet
 * @param ctx - canvas context
 * @param pallet
 * @param dimensions
 */
function drawProducts(ctx, pallet) {
  let products = pallet.products;
  ctx.fillStyle = "#FFFFFF";
  // sort by x desc
  products.sort((a, b) => {
    return b.x - a.x;
  });
  products.forEach(product => {
    //show if stack is higher than allowed
    const x = product.y;
    const y =
      pallet.getHeight() -
      pallet.pallet_height -
      product.getHeight() -
      product.z;
    const width = product.depth;
    const height = product.getHeight();
    ctx.fillStyle =
      product.status > 12 && product.status < 15
        ? "rgb(152, 209, 160)"
        : "rgb(255,255,255)";
    //check if product is too high or stack it is in
    if (
      product.getProductStack(products).getHeight() + pallet.pallet_height >
      pallet.max_height
    ) {
      ctx.fillStyle = "red";
    }
    ctx.fillRect(x, y, width, height); //draw rectangles
    ctx.lineWidth = 10;
    ctx.rect(x, y, width, height); //draw borders
    ctx.stroke();
  });
}

/**
 * gets height of product takes up on pallet
 * @param product
 * @return height
 */
function getProductHeight(product) {
  return product.is_flipped ? product.width : product.height;
}

/**
 * gets highest product height on the pallet
 * @param products array of products
 * @return max height
 */
function getHighestProduct(products) {
  let maxHeight = 0;
  products.forEach(product => {
    maxHeight = Math.max(maxHeight, getProductHeight(product) + product.z);
  });
  return maxHeight;
}
</script>

<style>
#canvas {
  background-color: white;
}
</style>
